module.exports = __webpack_public_path__ + "media/images/star-474a42ea05f7444db5703e19eb324c45.svg";